<div class="login-page">
  <div class="login-hero">
    <img src="assets/logos/logo-sociochaux@3x-300x269.png"
         alt="Logo MySociochaux"
         class="login-logo">
    <h1 class="login-brand">
      <span class="login-brand__my">My</span>Sociochaux
    </h1>
    <p class="login-tagline">L'espace des Socios</p>
  </div>

  <mat-card class="login-card" [class.login-card--error]="wrongPassword">
    <form class="login-form" (keydown.enter)="connection()">
      <div *ngIf="wrongPassword" class="login-error" [ngClass]="{ shake: shakeError }">
        <mat-icon>error_outline</mat-icon>
        <span>Identifiants incorrects</span>
        <mat-progress-bar mode="determinate" [value]="progress" color="warn"></mat-progress-bar>
      </div>

      <mat-form-field appearance="outline" class="login-field">
        <mat-label>Adresse email</mat-label>
        <mat-icon matPrefix>email</mat-icon>
        <input matInput [formControl]="emailFormControl" [errorStateMatcher]="matcher"
               type="email" name="email" id="email" placeholder="mon@adresse.fr" autocomplete="email">
        <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
          Merci d'entrer une adresse valide
        </mat-error>
        <mat-error *ngIf="emailFormControl.hasError('required')">
          L'email est <strong>obligatoire</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="login-field">
        <mat-label>Mot de passe</mat-label>
        <mat-icon matPrefix>lock</mat-icon>
        <input matInput [formControl]="passwordFormControl"
               [type]="showPassword ? 'text' : 'password'" name="password" id="password" autocomplete="current-password">
        <button matSuffix mat-icon-button aria-label="Afficher le mot de passe"
                (click)="showPassword = !showPassword" [attr.aria-pressed]="showPassword" type="button">
          <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <button mat-raised-button class="login-submit" (click)="connection()" type="button">
        Me connecter
      </button>
    </form>

    <button class="login-forgot" (click)="openDialog()" type="button">
      Mot de passe oublié ?
    </button>
  </mat-card>

  <div class="login-campaigns" *ngIf="campaigns.length > 0">
    <p class="login-campaigns__label">Campagnes en cours</p>
    <a mat-stroked-button *ngFor="let campaign of campaigns"
       [href]="'/#/c/' + campaign.slug" class="login-campaigns__btn">
      <mat-icon>campaign</mat-icon>
      {{ campaign.name }}
    </a>
  </div>

  <div class="login-legal">
    <a href="assets/legal/privacy-policy.html" target="_blank">Politique de confidentialité</a>
    <span class="login-legal__sep">·</span>
    <a href="assets/legal/terms-of-service.html" target="_blank">CGU</a>
  </div>
</div>
